import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
} from "@mui/material";
import NotesIcon from "@mui/icons-material/Notes";

export default function ObservacionesDialog(props) {
  return (
    <Dialog
      open={props.open}
      onClose={() => props.setopen(false)}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        <Typography variant="h6" fontWeight="bold" color="primary">
          Observaciones de otros requerimientos
        </Typography>
      </DialogTitle>

      <Divider />

      <DialogContent dividers>
        {props.datos && props.datos.length > 0 ? (
          <List>
            {props.datos.map((d, index) => (
              <ListItem
                key={index}
                sx={{
                  backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                  borderRadius: 2,
                  mb: 1,
                  boxShadow: 1,
                  alignItems: "flex-start",
                }}
              >
                <ListItemIcon>
                  <NotesIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography variant="subtitle2" color="text.secondary">
                      Requerimiento:{" "}
                      <Typography
                        component="span"
                        variant="subtitle2"
                        fontWeight="bold"
                        color="text.primary"
                      >
                        {d.idrequerimiento}
                      </Typography>
                    </Typography>
                  }
                  secondary={
                    <Typography variant="body1" color="text.primary">
                      {d.observaciones}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Box textAlign="center" py={2}>
            <Typography variant="body2" color="text.secondary">
              No hay observaciones registradas.
            </Typography>
          </Box>
        )}
      </DialogContent>

      <Divider />

      <DialogActions>
        <Button
          onClick={() => props.setopen(false)}
          variant="contained"
          color="primary"
          sx={{ borderRadius: 2 }}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
}